import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal , ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { environment} from '../../../environments/environment';

@Component({
  selector: 'app-super-admin-create',
  templateUrl: './super-admin-create.component.html',
  styleUrls: ['./super-admin-create.component.scss']
})
export class SuperAdminCreateComponent implements OnInit {
private BASE_URL: string = environment.BASEURL;
submitted = false;
errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
data={};userData="";
is_active='1';organisationData:any;
adminData:any;order_by:any='created_dttm';order:any='ASC';
emailError:string='';
phoneError:string='';
 checkboxValue: string='';
 isChecked: any;
 closeResult: any = '';
 isCheckeds:any = false;
 checkedValidation:any = 0;
 accessError:any=0;
  otp: any;

constructor(private contentAuthoringApi:ContentAuthoringService,
  private route: ActivatedRoute,private modalService: NgbModal,
  private router: Router,private spinner: NgxSpinnerService) {
    if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
   }
   txtOtp = new FormControl('');

 userForm = new FormGroup({
   first_name: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z-. ]*$")]),
   last_name: new FormControl('', [Validators.pattern("^[a-zA-Z-. ]*$")]),
   email: new FormControl('', [Validators.required, Validators.email,
   Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
   phone: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]),
   created_by: new FormControl('2'),
   change_pass_link: new FormControl(this.BASE_URL + '/#/create_password?type=2'),
   //change_pass_link: new FormControl(this.BASE_URL + '/create_password?type=2'),
   //organisation_id: new FormControl('', Validators.required),
   backend_user_mgmt: new FormControl(''),
   content_authoring_access: new FormControl(''),
   course_mgmt_access: new FormControl(''),
   user_mgmt_access: new FormControl(''),
   organisation_mgmt_access: new FormControl(''),
   reset_rqsts_access: new FormControl(''),
   reports_access: new FormControl(''),
   settings_access: new FormControl(''),
   assessment_access: new FormControl(''),
   ticket_access: new FormControl(''),
   user_type:new FormControl(2),
 });
  get f() { return this.userForm.controls; } 
  ngOnInit(): void {
//  this.getOrganisationList(this.is_active);
  this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
  }
  handeOtpChange(value: string[]): void {
    console.log(value);
  }

  handleFillEvent(value: string): void {
    console.log(value);
  }
  open(content: any) {
   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
     this.closeResult = `Closed with: ${result}`;
   }, (reason) => {
     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
   });
 }

 private getDismissReason(reason: any): string {
   if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
   } else {
     return `with: ${reason}`;
   }
 }
  /*******create customer user (normal user)******/

  generateOtp(){
    this.submitted = true;
    if(this.userForm.value.phone.length != 10 && this.userForm.value.phone.length != 0){
      this.phoneError = 'Please input valid phone number'; 
    }else{ this.phoneError = ''; }
    
    if(this.userForm.invalid) { this.spinner.hide(); return; }
    if(this.checkedValidation == 0){
      this.accessError = 1
      this.spinner.hide();
      return;
    }
   const postJson= {
      "email": this.adminData.email,
      "first_name": this.adminData.first_name
    }
    this.contentAuthoringApi.generateOtp(postJson).subscribe(
      (data)=>{
        if(data.status == 201 || data.status == 200){
          this.otp=data.otp
          document.getElementById('openId')?.click();
        }
      })
  }
  createUser(userForm:any)
  {
   //if(this.otp == this.txtOtp.value){
    this.spinner.show();
    this.submitted = true;
    if(this.userForm.value.phone.length != 10 && this.userForm.value.phone.length != 0){
      this.phoneError = 'Please input valid phone number'; 
    }else{ this.phoneError = ''; }
    
    if(this.userForm.invalid) { this.spinner.hide(); return; }
    if(this.checkedValidation == 0){
      this.accessError = 1
      this.spinner.hide();
      return;
    }
    
    this.contentAuthoringApi.createUser(this.userForm.value).subscribe(
      (data)=>{
        this.emailError = ''; this.phoneError = '';
       // console.log(data);return false;
      if(data.status == 201 || data.status == 200){
        this.spinner.hide();
        localStorage.setItem('userData', JSON.stringify(data.data));
        this.userData=JSON.stringify(data.data)
       // document.getElementById('successMsg')?.click();
       this.txtOtp.reset();
       this.modalService.dismissAll();
        this.router.navigate(['/user_successfully'], { queryParams: { p: "superAdmin" } });
      }
      else if(data.email_error || data.phone_error){
        this.spinner.hide();
        // this.txtOtp.reset();
        // this.modalService.dismissAll();
        this.errorInfo.isError = true;
        this.emailError = data.email_error;
        this.phoneError = data.phone_error;
      }else{
        this.spinner.hide();
        this.errorInfo.isError = true;
        // this.txtOtp.reset();
        // this.modalService.dismissAll();
        this.errorInfo.errorMsg = 'Something went wrong';
      }
      },
      (error) => { 
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    ); 
    // }
    // else{
    //   alert("Invalid OTP")
    // }
  }

  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }

 onChange(ob: MatCheckboxChange) {
   
   this.checkboxValue = ob.source.id;
   this.isChecked = ob.checked
    if (this.checkboxValue == "backend_user_mgmt" && this.isChecked) {
      this.isCheckeds= true;
    }
    if (this.checkboxValue == "backend_user_mgmt" && !this.isChecked) {
      this.isCheckeds= false;
    }
    if(this.isChecked){
      this.checkedValidation = 1;
    }
    if(!this.isChecked){
      this.checkedValidation = 0;
    }
 }
}
